import { render } from "./ProfileSettings.vue?vue&type=template&id=73f03026&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"

import "./ProfileSettings.vue?vue&type=style&index=0&id=73f03026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f03026"]])

export default __exports__